import React, { useState, useRef, useEffect } from "react";
import { motion } from "framer-motion";
import usePlayVideo from "../../CustomHooks/usePlayVideo";
import axiosClient from "../../axios-client";

const SeriePopup = ({
    modalRef,
    popupInfo,
    playSerie,
    playMovie,
    handleFavoriteClick,
    setShowModal
}) => {
    const [isHovered, setIsHovered] = useState(false);
    // const modalRef = useRef(null);
    const [selectedSeason, setSelectedSeason] = useState(1); // Default to Season 1
    const [currentEpisodes, setCurrentEpisodes] = useState([]);
    const [serieDetails, setSerieDetails] = useState({});

    const { playVideo } = usePlayVideo();
    const fetchEpisodes = async (idSerie, seasonNumber) => {
        try {
            const response = await axiosClient.get(`/episodes/${idSerie}/season/${seasonNumber}/`);
            setCurrentEpisodes(response.data);
        } catch (error) {
            // console.error("Error fetching episodes:", error);
        }
    };


    const fetchSerieDetails = async (id) => {
        try {
            const response = await axiosClient.get(`/series/${id}/`);


            setSerieDetails(response.data);

            // const recommendationsResponse = await fetch(
            //     `${baseUrl}/movie/${id}/recommendations?api_key=${API_KEY}&language=en-US&page=1`
            // );
            // const recommendationsData = await recommendationsResponse.json();
            // setSimilarMovies(recommendationsData.results);
        } catch (error) {
            // console.error("Error fetching movie details or recommendations:", error);
        }
    };

    useEffect(() => {

        fetchEpisodes(popupInfo?.id, selectedSeason);
        fetchSerieDetails(popupInfo?.id);
    }, [popupInfo?.id, selectedSeason]);

    return (
        <div className="mt-2 w-screen overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <motion.div

                initial={{ opacity: 1, scale: 0.5 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.5 }}
                transition={{ duration: 0.4, ease: "easeOut" }}
                className="relative flex  justify-center items-center  mx-4 mt-[2%] mb-[2%]"
            >
                {/* Content */}
                <div ref={modalRef} className="w-[750px]  overflow-y-auto border-0 rounded-lg shadow-lg relative flex flex-col bg-[#131022] outline-none focus:outline-none">
                    <div
                        className="relative"
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => setIsHovered(false)}
                    >
                        <video
                            poster={popupInfo.image}
                            className="w-full h-fit max-h-[430px] bg-center object-cover grid items-center"
                            src={popupInfo.trailerUrl}
                            autoPlay
                            controls={(popupInfo.trailerUrl && isHovered) ? true : false}
                            controlsList="nodownload"
                        />

                        {/* Buttons */}
                        <div
                            className={`z-50 absolute ${isHovered && popupInfo.trailerUrl ? "bottom-16" : "bottom-5"
                                } left-4 mb-3 items-center transition-all duration-300`}
                        >
                            {popupInfo.logo &&
                                <div className=" mb-7 text-white ml-4 font-medium  flex  ">
                                    <img className="object-fit h-[80px] " src={popupInfo.logo} />
                                </div>}
                            <div className="flex">
                                <button
                                    className="flex items-center justify-center bg-orange-400 text-white active:bg-orange-500 font-medium sm:font-bold uppercase text-xs px-4 sm:px-6 md:text-sm py-2 rounded shadow hover:shadow-lg cursor-pointer outline-none focus:outline-none mr-3 mb-1 ease-linear transition-all duration-150"
                                    type="button"
                                    onClick={() => {
                                        popupInfo.type === "series"
                                            ? playSerie(popupInfo)
                                            : playMovie(popupInfo);
                                    }}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-6 w-6 mr-1 text-white hover:text-gray-300 ease-linear transition-all duration-150"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                    {(popupInfo?.type !== "series") &&
                                        Object.keys(popupInfo?.watchHistory).length > 0 &&
                                        !popupInfo?.watchHistory?.isFinished
                                        ? "Continuer"
                                        : "Regarder"}
                                </button>

                                <div
                                    onClick={() =>
                                        handleFavoriteClick(popupInfo, popupInfo.title)
                                    }
                                    className="text-white w-10 h-10 border-[2px] rounded-full p-2 mr-1 backdrop-blur-[1px] hover:bg-white hover:text-black shadow-md cursor-pointer ease-linear transition-all duration-150"
                                >
                                    {popupInfo.isLiked ? (
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="white"
                                            viewBox="0 0 24 24"
                                            strokeWidth={1.5}
                                            stroke="currentColor"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                                            />
                                        </svg>
                                    ) : (
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            strokeWidth={1.5}
                                            stroke="currentColor"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                                            />
                                        </svg>
                                    )}
                                </div>
                            </div>

                        </div>
                    </div>

                    {/* Movie Info */}
                    <div className="p-5 py-5 items-center -mb-6 mt-2 flex justify-between sm:mb-0 sm:mt-0 sm:py-2 sm:pt-6 rounded-t">

                        <h3 className="text-3xl mb-2 font-semibold text-white">
                            {popupInfo.title}
                        </h3>
                        <div className="items-end justify-end">
                            <h1 className="flex text-orange-400 text-lg leading-relaxed">
                                <p className="font-medium">
                                {popupInfo.serie_totalSeasons} Saison{popupInfo.serie_totalSeasons > 1 ? "s" : ""}

                                </p>
                            </h1>
                            {popupInfo.min_age ?
                                <div className="flex justify-end ">
                                    <p className=" px-1 border-white border-[2px] text-white font-medium w-fit text-md">+{popupInfo.min_age}</p>
                                </div>
                                :
                                <div className="flex justify-end ">
                                    <p className=" text-orange-400 w-fit font-medium text-sm">Convient à tous âges</p>
                                </div>
                            }


                        </div>

                    </div>

                    <div className="relative px-4 sm:px-6 flex-auto mt-5">
                        <div className="bg-orange-300 opacity-30 h-[0.05rem]"></div>

                        {/* Flex Container */}
                        <div className="flex flex-col sm:flex-row gap-4 sm:gap-8 mt-4 sm:mt-7">

                            {/* Description - 70% */}
                            <p className="text-neutral-100 text-xs md:text-lg leading-relaxed line-clamp-4 sm:line-clamp-none ">
                                {popupInfo.description}
                            </p>

                            {/* Details - 30% */}


                        </div>
                    </div>
                    <div className="relative px-2 sm:p-6 flex-auto">
                            {popupInfo?.language &&
                                <h1 className="flex text-neutral-400 text-sm leading-relaxed">
                                    Langue :
                                    <p className="text-white ml-2 ">
                                        {popupInfo.language}
                                    </p>
                                </h1>
                            }
                            {popupInfo?.origin_country &&
                                <h1 className="flex text-neutral-400 text-sm leading-relaxed">
                                    Pays d'origine :
                                    <p className="text-white ml-2 ">
                                        {popupInfo.origin_country}
                                    </p>
                                </h1>
                            }

                            {popupInfo?.category_names?.length>0 &&
                                <h1 className="flex text-neutral-400 text-sm leading-relaxed">
                                    Genres :
                                    <p className="text-white ml-2 ">
                                        {popupInfo?.category_names?.slice(0, 3).join(", ")}
                                    </p>
                                </h1>
                            }
                            {popupInfo?.actors?.length > 0 &&
                                <h1 className="flex text-neutral-400 text-sm leading-relaxed">
                                    Acteurs principaux :
                                    <p className="text-white ml-2 ">
                                        {popupInfo.actors?.join(", ")}
                                    </p>
                                </h1>
                            }
                            {popupInfo?.director_name &&
                                <h1 className="flex text-neutral-400 text-sm leading-relaxed">
                                    Réalisation :
                                    <p className="text-white ml-2 ">
                                        {popupInfo.director_name}
                                    </p>
                                </h1>
                            }


                        </div>

                    <div className="flow-root">
                        {/* Season Selector */}
                        <div className="px-5 flex justify-end items-center w-[100%] mx-auto pb-6">
                            <select
                                id="season-select"
                                className="block w-32 p-2 text-white border  rounded-lg shadow-sm focus:ring-orange-500 focus:border-orange-500 bg-black/20  border-orange-500"
                                value={selectedSeason}
                                onChange={(e) => setSelectedSeason(e.target.value)}
                            >
                                {Array.from({ length: popupInfo.serie_totalSeasons }, (_, index) => (
                                    <option
                                        key={index + 1} // Use index + 1 to start the season numbering at 1
                                        className="bg-[#231634]"
                                        value={index + 1}
                                    >
                                        Season {index + 1}
                                    </option>
                                ))}
                            </select>
                        </div>


                        {/* Divider */}
                        {/* <div className="h-[1px] bg-gray-700" /> */}

                        {/* Episode List */}
                        {currentEpisodes.length > 0 ?
                            <ul
                                role="list"
                                className="divide-y divide-gray-700 "
                            >
                                {currentEpisodes.map((episode) => (
                                    <li onClick={() => playVideo(episode.id, "episode", null, null, episode?.seasonNumber)} key={episode.id} className="py-4">
                                        <div className="flex items-center space-x-6 px-5 mx-auto">
                                            <div className="text-2xl md:text-3xl font-bold text-orange-400">{episode.episodeNumber}</div>
                                            <div
                                                className="hidden md:flex flex-shrink-0"
                                                onClick={() => playVideo(episode.id, "episode", null, null, episode?.seasonNumber)}
                                            >
                                                <img
                                                    className="cursor-pointer w-50 h-24 rounded-lg object-cover transition-transform duration-300 hover:scale-105"
                                                    src={popupInfo.image}
                                                    alt="Episode Thumbnail"
                                                />
                                            </div>
                                            <div className="flex-1 min-w-0">
                                                <p className="text-xl md:text-xl mb-3 font-medium text-white">
                                                    {`Episode ${episode.episodeNumber}: ${episode.title}`}
                                                </p>
                                                <p className="text-sm md:text-md text-teal-300">
                                                    {episode.duration < 60
                                                        ? `${episode.duration} secs`
                                                        : episode.duration < 3600
                                                            ? `${Math.floor(episode.duration / 60)} min${Math.floor(episode.duration / 60) > 1 ? "s" : ""} ${episode.duration % 60 > 0 ? `${episode.duration % 60} secs` : ""
                                                            }`
                                                            : `${Math.floor(episode.duration / 3600)} hr${Math.floor(episode.duration / 3600) > 1 ? "s" : ""} ${Math.floor((episode.duration % 3600) / 60) > 0
                                                                ? `${Math.floor((episode.duration % 3600) / 60)} min${Math.floor((episode.duration % 3600) / 60) > 1 ? "s" : ""}`
                                                                : ""
                                                            } ${episode.duration % 60 > 0 ? `${episode.duration % 60} secs` : ""}`}
                                                </p>

                                                <p className="text-sm md:text-md text-gray-300">
                                                    {episode.description}
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                            :
                            <div className="flex justify-center items-center">
                                <h1 className="flex text-neutral-500 text-sm leading-relaxed">
                                    Il n'y a pas encore d'épisodes disponibles pour cette saison

                                </h1>
                            </div>
                        }

                    </div>
                    {/* Footer */}
                    <div className="sm:flex items-end justify-end p-2 rounded-b">
                       

                        <div className="flex align-bottom justify-end p-2">
                            <button
                                className="flex items-center  text-red-500 background-transparent font-medium sm:font-bold uppercase px-2 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                type="button"
                                onClick={() => setShowModal(false)}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth={1.5}
                                    stroke="currentColor"
                                    className="w-6 h-6 mr-1"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                    />
                                </svg>
                                Fermer
                            </button>
                        </div>
                    </div>


                </div>
            </motion.div>
        </div>
    );
};

export default SeriePopup;
